import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export default function LoginScreen({
  password,
  setPassword,
  passwordError,
  setPasswordError,
  showPassword,
  setShowPassword,
  onSubmit,
}) {
  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center p-6 relative" data-testid="password-screen">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(/wve-bg.jpg)', opacity: 0.2 }} />
      <Card className="w-full max-w-md bg-white border-stone-100 shadow-lg relative z-10">
        <CardHeader className="text-center pb-2">
          {passwordError ? (
            <div className="relative mx-auto mb-4">
              <div className="relative w-32 h-32 mx-auto overflow-hidden rounded-full">
                <img
                  src="https://customer-assets.emergentagent.com/job_balance-due-planner/artifacts/ndt0q4zp_TEAM%20PHOTOS%2009-08-17%20007.jpg"
                  alt="Sad face"
                  className="w-full h-full object-cover object-top grayscale brightness-75"
                  style={{ filter: 'grayscale(100%) brightness(0.7) saturate(0.5)' }}
                />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <span className="absolute text-4xl" style={{ top: '35%', left: '20%', transform: 'rotate(-10deg)' }}>💧</span>
                  <span className="absolute text-4xl" style={{ top: '40%', right: '20%', transform: 'rotate(10deg)' }}>💧</span>
                  <span className="absolute text-3xl animate-bounce" style={{ top: '50%', left: '25%' }}>😢</span>
                </div>
              </div>
              <p className="text-2xl mt-3 animate-pulse">😭😭😭</p>
            </div>
          ) : (
            <div className="mx-auto w-20 h-20 rounded-full overflow-hidden mb-4">
              <img src="/wve-logo.png" alt="WVE" className="w-full h-full object-cover" />
            </div>
          )}
          <CardTitle className="text-2xl font-serif text-stone-900">
            WVE Forecaster
          </CardTitle>
          <p className="text-sm text-stone-500 mt-1">Balance Income Forecaster</p>
        </CardHeader>
        <CardContent className="pt-4">
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError(false);
                  }}
                  className={`w-full pr-10 ${passwordError ? 'border-red-500 focus:ring-red-500' : ''}`}
                  data-testid="password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-600 transition-colors"
                  data-testid="toggle-password-visibility"
                >
                  {showPassword ? (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                  )}
                </button>
              </div>
              {passwordError && (
                <div className="mt-3 p-3 bg-red-50 rounded-lg border border-red-200">
                  <p className="text-sm text-red-600 font-medium text-center">
                    Wrong password! You've made me very sad... 😢
                  </p>
                  <p className="text-xs text-red-500 text-center mt-1">
                    Please try again!
                  </p>
                </div>
              )}
            </div>
            <Button
              type="submit"
              className="w-full bg-stone-900 text-white hover:bg-stone-800"
              data-testid="password-submit-btn"
            >
              Access Dashboard
            </Button>
          </form>
          <div className="mt-6 p-4 bg-stone-50 rounded-lg border border-stone-100">
            <p className="text-xs text-stone-500 leading-relaxed">
              <span className="font-medium text-stone-600">Hint:</span> The password is all lowercase & is your favourite milkshake then a + and then your favourite cartoon tv show
            </p>
            <p className="text-xs text-stone-400 mt-2 italic">
              Example: oreo+familyguy
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
